import script from "./ProjectCardDocument.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectCardDocument.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectCardDocument.vue?vue&type=style&index=0&id=d8b4b1c2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8b4b1c2"]])

export default __exports__